import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { ImageReviewStatus, UpdateImageReview } from "../../../schemas/location";
import { queryKeys } from "../../query-keys";

export function useImageReviews(status: ImageReviewStatus | "all" = "pending") {
	return useQuery({
		queryKey: queryKeys.imageReviews.list(status),
		queryFn: () => adminApi.locations.imageReviews.list(status),
	});
}

export function useUpdateImageReview() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateImageReview }) =>
			adminApi.locations.imageReviews.update(id, body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.imageReviews.all });
			queryClient.invalidateQueries({ queryKey: queryKeys.locations.all });
		},
	});
}
